<template>
  <div class="map_box">
		<!-- 头部 -->
    <mapHeader :data_type="is_data_checked"></mapHeader>
		<!-- 内容 -->
    <div id="map_subject">
			<!-- 左侧 -->
      <div class="display_scale" id="display_scale">

        <div style="width:240px;margin:0 auto;margin-top:20px;">
          <!-- <span>选择地图：</span> -->
          <el-select style="width:240px;" v-model="tab_active_name" placeholder="请选择" @change="toggle_tabs">
            <el-option v-for="(o,i) in tab_name_list" :key="i" :label="o.label" :value="o.value">
            </el-option>
          </el-select>
        </div>

        <!-- 3个色块 -->
        <ul class="color_code">
          <li v-for="(o,i) of $public.color_code" :key="i">
            <span class="color_code_bag" :style="{backgroundColor:o.color}"></span>
            <span class="color_code_title">{{o.name}}</span>
          </li>
        </ul>

        <!-- 标签页-精准扶贫 -->
        <div class="distribution" v-show="tab_active_name==='jzfp'">
          <ul>
            <li v-for="(o,i) of progress_bar_data1" :key="i" @click="toggle_swiper(i)">
              <span>{{o.name}}</span>
              <el-progress style="cursor: pointer;" :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-劳动维权 -->
        <div class="distribution" v-show="tab_active_name==='ldwq'">
          <ul>
            <li v-for="(o,i) of progress_bar_data2" :key="i">
              <span>{{o.name}}</span>
              <el-progress :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-岗位招聘 -->
        <div class="distribution" v-show="tab_active_name==='gwzp'">
          <ul>
            <li v-for="(o,i) of progress_bar_data3" :key="i">
              <span>{{o.name}}</span>
              <el-progress :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-高校毕业生 -->
        <div class="distribution" v-show="tab_active_name==='gxxs'">
          <ul>
            <li v-for="(o,i) of progress_bar_data4" :key="i" @click="toggle_swiper(i)">
              <span>{{o.name}}</span>
              <el-progress style="cursor: pointer;" :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-退役军人 -->
        <div class="distribution" v-show="tab_active_name==='tyjr'">
          <ul>
            <li v-for="(o,i) of progress_bar_data5" :key="i" @click="toggle_swiper(i)">
              <span>{{o.name}}</span>
              <el-progress style="cursor: pointer;" :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-残疾人 -->
        <div class="distribution" v-show="tab_active_name==='cjrs'">
          <ul>
            <li v-for="(o,i) of progress_bar_data6" :key="i" @click="toggle_swiper(i)">
              <span>{{o.name}}</span>
              <el-progress style="cursor: pointer;" :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-退捕渔民 -->
        <div class="distribution" v-show="tab_active_name==='tbym'">
          <ul>
            <li v-for="(o,i) of progress_bar_data7" :key="i" @click="toggle_swiper(i)">
              <span>{{o.name}}</span>
              <el-progress style="cursor: pointer;" :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>
        <!-- 标签页-其他人 -->
        <div class="distribution" v-show="tab_active_name==='qtry'">
          <ul>
            <li v-for="(o,i) of progress_bar_data8" :key="i" @click="toggle_swiper(i)">
              <span>{{o.name}}</span>
              <el-progress style="cursor: pointer;" :text-inside="true" :stroke-width="18" :color="o.color" :percentage="o.proportion"></el-progress>
            </li>
          </ul>
        </div>

        <!-- 滚动条 -->
        <div class="swiper">
          <myswiper
            ref="myswiper"
            :list="swiper_data"
            :labels="labels"
            :isStart="is_swiper_start"
            :tab_active_name="tab_active_name"
            :current_swiper_type="current_swiper_type"></myswiper>
        </div>

      </div>

			<!-- 地图 -->
      <div id="container">
				<!-- 右侧刷新按钮 -->
        <!-- <div class="Refresh" @click="initPage()"></div> -->
      </div>
      
      <!-- 地图弹框 -->
      <!-- <div class="Dialog_box" :class="[open_map_dialog?'display_frame':'close_frame']"> -->
      <div class="Dialog_box" :style="open_map_dialog?'':'display:none;'">
        <p class="el-icon-close close_button" @click="open_map_dialog=false"></p>
        <div class="map_info">
          <div class="map_info-img">
            <img :src="map_dialog_data.img" />
          </div>
          <div class="map_info-info">
            <p class="map_info-systemname">{{map_dialog_data.title}}</p>
            <p class="map_info-areaname">{{map_dialog_data.name}}</p>
            <div class="map_info-nums">
              <ul v-if="tab_active_name==='jzfp'">
                <li><p>总人口：{{map_dialog_data.totalPersons}} 人</p></li>
                <li><p>贫困人员：{{map_dialog_data.poorTotalPersons}} 人</p></li>
                <li><p>已脱贫：{{map_dialog_data.poorLaborTotalPersons}} 人</p></li>
                <li><p>未脱贫：{{map_dialog_data.lostPoorLaborPersons}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='ldwq'">
                <li><p>监测总数：{{map_dialog_data.ldwqAll}} 人</p></li>
                <li><p>预警总数：{{map_dialog_data.ldwqEarlyWarning}} 人</p></li>
                <li><p>已解决：{{map_dialog_data.dealLostSalary}} 人</p></li>
                <li><p>未解决：{{map_dialog_data.notDealLostSalary}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='gwzp'">
                <li><p>招聘总数：{{map_dialog_data.needPersons}} 人</p></li>
                <li><p>已招人数：{{map_dialog_data.workPersons}} 人</p></li>
                <li><p>空岗人数：{{map_dialog_data.emptyWorkPersons}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='gxxs'">
                <li><p>监测总数：{{map_dialog_data.hiStudentAll}} 人</p></li>
                <li><p>已就业人员：{{map_dialog_data.hiStudentHasJob}} 人</p></li>
                <li><p>无就业意愿：{{map_dialog_data.hiStudentNoJobNoWish}} 人</p></li>
                <li><p>有就业意向：{{map_dialog_data.hiStudentNoJobHaveWish}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='tyjr'">
                <li><p>监测总数：{{map_dialog_data.soldierAll}} 人</p></li>
                <li><p>已就业人员：{{map_dialog_data.soldierHasJob}} 人</p></li>
                <li><p>无就业意愿：{{map_dialog_data.soldierNoJobNoWish}} 人</p></li>
                <li><p>有就业意向：{{map_dialog_data.soldierNoJobHaveWish}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='cjrs'">
                <li><p>监测总数：{{map_dialog_data.disableAll}} 人</p></li>
                <li><p>已就业人员：{{map_dialog_data.disableHasJob}} 人</p></li>
                <li><p>无就业意愿：{{map_dialog_data.disableNoJobNoWish}} 人</p></li>
                <li><p>有就业意向：{{map_dialog_data.disableNoJobHaveWish}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='tbym'">
                <li><p>监测总数：{{map_dialog_data.disableAll}} 人</p></li>
                <li><p>已就业人员：{{map_dialog_data.fishManHasJob}} 人</p></li>
                <li><p>无就业意愿：{{map_dialog_data.fishManNoJobNoWish}} 人</p></li>
                <li><p>有就业意向：{{map_dialog_data.fishManNoJobHaveWish}} 人</p></li>
              </ul>
              <ul v-if="tab_active_name==='qtry'">
                <li><p>监测总数：{{map_dialog_data.lostJobAll}} 人</p></li>
                <li><p>已就业人员：{{map_dialog_data.lostJobHasJob}} 人</p></li>
                <li><p>无就业意愿：{{map_dialog_data.lostJobNoJobNoWish}} 人</p></li>
                <li><p>有就业意向：{{map_dialog_data.lostJobNoJobHaveWish}} 人</p></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="map_Administrators">
          <h4>简 介：</h4>
          <div class="brief_introduction">{{map_dialog_data.showDesc}}</div>
        </div>
      </div>
    </div>
    
		<!-- 底部 -->
    <div class="main-footer">
      <span>版权所有 ©成都竞成人力资源服务股份有限公司</span>&nbsp;
      <span>蜀ICP备11025845号 蜀ICP备11025845号-1</span>
    </div>
    <div class="waiting" v-show="waiting">切换中</div>
    <!-- <div class="waiting" v-show="waiting">地图切换加载中，请稍等...</div> -->
  </div>
</template>

<script>
import myswiper from '@/components/swiper/index'
import { publicData } from '@/publicData/index'
import mixins from '@/Mixins'
export default {
  mixins: [ mixins ],
  components: { myswiper },
  data() {
    return {
      // 地图数据
      map: null,                      // 地图实例
      map_zoom: 4,                    // 每一个管理员进去系统时的放大倍数
      map_center: [100.455, 38.9329], // 制定地图的中心点

      // 控制器
      open_map_dialog: false,         // 控制开启地图弹框
      // is_dbclick: false,           // 控制是不是双击 双击后禁止再默认渲染地区账号
      is_data_checked: false,         // 控制是否选择了地区 进入表单系统
      waiting: false,

      tab_active_name: 'jzfp',        // 当前tab
      tab_name_list: [
        {label:'脱贫人口就业监测',value:'jzfp'},
        {label:'单位岗位招聘监测',value:'gwzp'},
        {label:'劳动维权预警监测',value:'ldwq'},
        {label:'高校学生就业监测',value:'gxxs'},
        {label:'退役军人就业监测',value:'tyjr'},
        {label:'残疾人士就业监测',value:'cjrs'},
        {label:'退捕渔民就业监测',value:'tbym'},
        {label:'其他人员就业监测',value:'qtry'},
      ],

      areaId_current: 0,              // 当前所在地区的地区ID
      areaId_onclick: 0,              // 单击所在地区的地区ID

      child_city_data: [],            // 子城市数据
      map_dialog_data: {},            // 地图弹框数据
      
      progress_bar_dom: [],           // 进度条dom元素
      progress_bar_data1: [
        { name:'脱贫劳动力', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
    	],
      progress_bar_data2: [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'预警总人数', color:'#6ec245', proportion:0,},
        { name:'已解决人数', color:'#ddd05e', proportion:0,},
        { name:'待解决人数', color:'#ca5857', proportion:0,},
    	],
      progress_bar_data3: [
        { name:'招聘人数', color:'#477bd8', proportion:0,},
        { name:'已招人数', color:'#6ec245', proportion:0,},
        { name:'空岗人数', color:'#ddd05e', proportion:0,},
      ],
      progress_bar_data4: [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ],
      progress_bar_data5: [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ],
      progress_bar_data6: [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ],
      progress_bar_data7: [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ],
      progress_bar_data8: [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ],
      
      is_swiper_start: false,         // 控制滚动条是否滚动
      current_swiper_type: 0,         // 记录点击了脱贫劳动力的哪个进度条
      swiper_data_fp: [],             // 滚动条数据 脱贫劳动力 高校毕业生总人数 退役军人总人数 残疾人总人数
      swiper_data_gwzp: [],           // 滚动条数据 岗位招聘
      swiper_data_fp_click: [],       // 滚动条数据 已就业 未就业无意向 未就业有意向
      labels1: [
        {label:'对象姓名',str:'name',prefixNum:1,starNum:2},
        {label:'联系电话',str:'phone',prefixNum:7,starNum:4},
        {label:'身份证号',str:'idCard',prefixNum:10,starNum:8},
      ],
      labels2: [
        {label:'单位名称',str:'organizationName',prefixNum:0,starNum:0},
        {label:'招聘人数',str:'needPersons',prefixNum:0,starNum:0},
        {label:'岗位名称',str:'jobName',prefixNum:0,starNum:0},
        {label:'联系电话',str:'phone',prefixNum:7,starNum:4},
      ]
    }
  },
  computed:{
    swiper_data() {
      switch (this.tab_active_name) {
        case 'gwzp': return this.swiper_data_gwzp
        case 'ldwq': return this.swiper_data_fp
        default: return this.current_swiper_type === 0 ? this.swiper_data_fp : this.swiper_data_fp_click
      }
    },
    labels() {
      switch (this.tab_active_name) {
        case 'gwzp': return this.labels2
        default: return this.labels1
      }
    },
  },
  methods: {
    // 点击tabs 切换
    toggle_tabs(val) {
      console.log('%cval:', 'color: #0f0;', val)
      this.tab_active_name = val

      this.swiper_data_gwzp = []
      this.swiper_data_fp = []
      this.swiper_data_fp_click = []

      this.progress_bar_data1 = [
        { name:'脱贫劳动力', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
    	]
      this.progress_bar_data2 = [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'预警总人数', color:'#6ec245', proportion:0,},
        { name:'已解决人数', color:'#ddd05e', proportion:0,},
        { name:'待解决人数', color:'#ca5857', proportion:0,},
    	]
      this.progress_bar_data3 = [
        { name:'招聘人数', color:'#477bd8', proportion:0,},
        { name:'已招人数', color:'#6ec245', proportion:0,},
        { name:'空岗人数', color:'#ddd05e', proportion:0,},
      ]
      this.progress_bar_data4 = [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ]
      this.progress_bar_data5 = [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ]
      this.progress_bar_data6 = [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ]
      this.progress_bar_data7 = [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ]
      this.progress_bar_data8 = [
        { name:'监测总人数', color:'#477bd8', proportion:0,},
        { name:'已就业人员', color:'#6ec245', proportion:0,},
        { name:'未就业人员(无就业意愿)', color:'#ddd05e', proportion:0,},
        { name:'未就业人员(有就业意向)', color:'#ca5857', proportion:0,},
      ]

      this.current_swiper_type = 0
      this.waiting = true
      this.open_map_dialog = false
      this.map = null
      this.initPage()
    },
    // 点击扶贫tabs中的进度条 切换
    toggle_swiper(i) {
      this.current_swiper_type = i
      let requestData = { areaId: this.areaId_onclick === 0 ? this.areaId_current : this.areaId_onclick }
      switch (i) {
        case 0: console.log(i); break;
        case 1: requestData.workAddress = 'yes'; break;
        case 2: requestData.jobWish = '否'; break;
        case 3: requestData.jobWish = '是'; break;
      }
      switch (this.tab_active_name) {
        case 'jzfp': requestData.jobGroup = '贫困人员'; break;
        case 'gxxs': requestData.jobGroup = '高校毕业生'; break;
        case 'tyjr': requestData.jobGroup = '退役军人'; break;
        case 'cjrs': requestData.jobGroup = '残疾人'; break;
        case 'tbym': requestData.jobGroup = '退捕渔民'; break;
        case 'qtry': requestData.jobGroup = '其它失业人员'; break;
      }
      console.log('%crequestData:', 'color: #f0f;', requestData)
      this.$api.get_swiper_data(requestData).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log('%cswiper:', 'color: #f00;', _R)
          this.swiper_data_fp_click = _R
        } else {
          this._status(res.data)
        }
      })
    },


    // 页面初始化
    initPage() {
      // 先获取用户信息中的areaID 判断账号类型
      this.$api.get_user_login_info().then(res => {
        if (res.data.status === 0) {
          const _D = JSON.parse(res.data.data)
          let areaId = _D.areaId
          this.areaId_current = areaId === '' ? 0 : areaId
          // 根据areaID 判断是否为地区账号
          // 如果是地区账号 就设置中心点
          // 如果是超级管理员 直接绘制地图标点
          if (areaId != 0) {
            this.$api.get_area_info({ areaId }).then(_res => {
              if (_res.data.status === 0) {
                const _d = JSON.parse(_res.data.data)
                this.map_center[0] = Number(_d.lng) // 根据areaId设置地图的中心点
                this.map_center[1] = Number(_d.lat) // 根据areaId设置地图的中心点
                // 地区账号 需要先渲染一次 左侧数据
                this.$api.mapSummation({ areaId }).then(_res => {
                  if (_res.data.status === 0) {
                    const _D = JSON.parse(_res.data.data)
                    this.progress_bar_handler(_D)
                    this.swiper_handler(areaId)
                    this.is_swiper_start = true
                    this.is_data_checked = true
                    localStorage.setItem('data', JSON.stringify(_D))
                    localStorage.setItem('id', JSON.stringify(areaId))
                  } else {
                    this._status(_res.data)
                  }
                })
              } else {
                this._status(_res.data)
              }
            })
          }
          this.get_map_city_data() // 绘制地图标点
        } else{
          this._status(res.data)
        }
      })
    },
    // 获取子城市列表
    get_map_city_data() {
			this.child_city_data = [] // 先置空 再获取子城市列表
      this.$api.get_Regional_information({ areaId: this.areaId_current }).then(res => {
        if (res.data.status === 0) {
					const _D = JSON.parse(res.data.data)
          this.map_zoom = (_D[0].level + 2) * 2 // 设置地图放大级别
          this.data_length = _D.length // 记录子城市的个数
          _D.forEach((o, i) => {
            this.get_left_side_data(o.id, o, i)
          })
        } else {
          this._status(res.data)
        }
      })
    },
    // 得到城市数据
    get_left_side_data(areaId, item, index) {
      return this.$api.mapSummation({ areaId }).then(_res => {
        if (_res.data.status === 0) {
          const _D = JSON.parse(_res.data.data)
          this.create_marker(_D, item, index)
        } else {
          this._status(_res.data)
        }
      })
    },
		// 生成各个子城市的标点
		create_marker(city_data, item, index) {
			let obj = {}
			obj.population = city_data
			obj.name = item.name
			obj.id = item.id
			obj.level = item.level
			obj.center = [Number(item.lng), Number(item.lat)]
			obj.icon = this.set_marker_icon(item.level)
			obj.index = index
			obj.content = this.set_marker_content(item, city_data)
			this.child_city_data.push(obj)
			
			this.data_length === this.child_city_data.length ? this.create_map() : '' // 所有数据处理完成后 渲染地图
		},
		// 根据级别 设置标点icon颜色
		set_marker_icon(level) {
			switch (level) {
				case 0: return require('../assets/position/position.png')
				case 1: return require('../assets/position/position1.png')
				case 2: return require('../assets/position/position2.png')
				case 3: return require('../assets/position/position3.png')
				case 4: return require('../assets/position/position4.png')
				default: return
			}
		},
		// 判断级别 设置标点文字说明背景色
		set_marker_content(item, city_data) {
			switch (item.level) {
				case 0: return this.set_marker_htmlCode(item, city_data)
				case 1: return this.set_marker_htmlCode(item, city_data, 'map_province_city')
				case 2: return this.set_marker_htmlCode(item, city_data, 'map_province_area')
				case 3: return this.set_marker_htmlCode(item, city_data, 'map_province_county')
				case 4: return this.set_marker_htmlCode(item, city_data, 'map_province_village')
				default: return
			}
		},
		// 根据级别 设置标点文字说明内容
		set_marker_htmlCode(item, city_data, active_class = '') {
      let {
        haveJob, noJobNoWish, noJobHaveWish,
        dealLostSalary,notDealLostSalary,
        needPersons,
        hiStudentHasJob, hiStudentNoJobNoWish, hiStudentNoJobHaveWish,
        soldierHasJob, soldierNoJobNoWish, soldierNoJobHaveWish,
        disableHasJob, disableNoJobNoWish, disableNoJobHaveWish,
        fishManHasJob, fishManNoJobNoWish, fishManNoJobHaveWish,
        lostJobHasJob, lostJobNoJobNoWish, lostJobNoJobHaveWish,
      } = city_data

      let ldwqAll = haveJob + noJobNoWish + noJobHaveWish
      let ldwqEarlyWarning = dealLostSalary + notDealLostSalary
      let hiStudentAll = hiStudentHasJob + hiStudentNoJobNoWish + hiStudentNoJobHaveWish // 
      let soldierAll = soldierHasJob + soldierNoJobNoWish + soldierNoJobHaveWish // 
      let disableAll = disableHasJob + disableNoJobNoWish + disableNoJobHaveWish // 
      let fishManAll = fishManHasJob + fishManNoJobNoWish + fishManNoJobHaveWish // 
      let lostJobAll = lostJobHasJob + lostJobNoJobNoWish + lostJobNoJobHaveWish // 

      // console.log(this.tab_active_name)
      let showNumber = ''
      switch (this.tab_active_name) {
        case 'jzfp': showNumber = ldwqAll; break;
        case 'ldwq': showNumber = ldwqEarlyWarning; break;
        case 'gwzp': showNumber = needPersons; break;
        case 'gxxs': showNumber = hiStudentAll; break;
        case 'tyjr': showNumber = soldierAll; break;
        case 'cjrs': showNumber = disableAll; break;
        case 'tbym': showNumber = fishManAll; break;
        case 'qtry': showNumber = lostJobAll; break;
      }

      return `<div class='map_province'>
        <div class='map_province_title'> ${item.name}</div>
        <div class='map_province_conter ${active_class}'>
          <div>${showNumber + '人'}</div>
        </div>
      </div>`
      // 标点样式 3行
      // return `<div class='map_province'>
      //     <div class='map_province_title'> ${item.name}</div>
      //     <div class='map_province_conter ${active_class}'>
      //       <div>扶贫：${ldwqAll + '人'}</div>
      //       <div>维权：${ldwqEarlyWarning + '人'}</div>
      //       <div>招聘：${needPersons + '人'}</div>
      //     </div>
      //   </div>`
		},
    // 绘制标点
    create_map() {
      let vm = this
			var timer = null
      // 单击 单击 单击 单击 地图上已经绘制的标点
      var _onClick = e => {
        // console.log('onClick start')
        if (timer) { clearTimeout(timer) }
        // 通过延时处理单击事件和双击事件的冲突
        timer = setTimeout(() => {
          // console.log('onClick timer start')
          console.log(e)
          let markerExtData = JSON.parse(JSON.stringify(e.target.getExtData()))
          let id = markerExtData.id,
              name = markerExtData.name,
              population = JSON.parse(JSON.stringify(markerExtData.population))
          this.areaId_onclick = id
          if (id) {
            // console.log('onClick id == true')
            // 查询点击地区对应的地区图片
            vm.$api.get_img_id({ id }).then(_res => {
              if (_res.data.status === 0) {
                let _D = JSON.parse(_res.data.data)
                // console.log(_D)
                population.showDesc = _D.showDesc
                population.totalPersons = _D.totalPersons
                population.title = _D.title
                population.poorTotalPersons = _D.poorTotalPersons
                population.poorLaborTotalPersons = _D.poorLaborTotalPersons
                population.lostPoorLaborPersons = _D.lostPoorLaborPersons
                // population.ldwqAll = _D.haveJob + _D.noJobNoWish + _D.noJobHaveWish
                // population.ldwqEarlyWarning = _D.dealLostSalary + _D.notDealLostSalary
                // population.dealLostSalary = _D.dealLostSalary
                // population.notDealLostSalary = _D.notDealLostSalary
                population.name = name
                if (_D.showImgId === '') { population.img = require('@/assets/logo.png') }
                else { population.img = vm.$api.see_img({ id: _D.showImgId }) }
                vm.map_dialog_data = population
                console.log('%cpopulation:','color:green',population)
                vm.open_map_dialog = true
              } else {
                this._status(_res.data)
              }
            })
            vm.progress_bar_handler(population)
            vm.swiper_handler(id)
            vm.is_swiper_start = true
            vm.is_data_checked = true
            vm.current_swiper_type = 0
            localStorage.setItem('data', JSON.stringify(population))
            localStorage.setItem('id', JSON.stringify(id))
          } else {
            vm.is_data_checked = false
          }
        }, 500) //延时500毫秒执行
			}
      // 双击 双击 双击 双击 地图上已经绘制的标点
      var _dblclick = e => {
        // console.log(222)
        if (timer) { clearTimeout(timer) } // 取消上次延时未执行的方法
        let markerExtData = JSON.parse(JSON.stringify(e.target.getExtData())) 
        vm.areaId_current = markerExtData.id
        console.log('%careaId_current:','color:red',vm.areaId_current)
        vm.get_map_city_data()
			}
			
      if (vm.map === null) { vm.initMap() } // 如果当前地图未初始化 先初始化 否则跳过初始化 直接绘制标点
      var markers = []
      for (let i = 0; i < Array.from(vm.child_city_data).length; i++) {
        var marker = new AMap.Marker({
          position: vm.child_city_data[i].center,
          map: vm.map,
          extData:{
            index: vm.child_city_data[i].index,
            id: vm.child_city_data[i].id,
            name: vm.child_city_data[i].name,
            population: vm.child_city_data[i].population,
            level: vm.child_city_data[i].level,
          },
          icon: new AMap.Icon({
            size: new AMap.Size(22, 22),
            image: vm.child_city_data[i].icon,
            imageSize: new AMap.Size(22, 22)
          })
        }) // 实例化marker
        marker.setLabel({
          content: vm.child_city_data[i].content,
          offset: new AMap.Pixel(1, -4),
          direction: 'top' // 设置文本标注方位
        })
        markers.push(marker)
        AMap.event.addListener(marker, 'click', _onClick) // 监听单击事件
        AMap.event.addListener(marker, 'dblclick', _dblclick) // 监听双击事件
      }
    },

    // 设置左侧进度条
    progress_bar_handler(data) {
      console.log('%c左侧进度条:', 'color: #0ff;', data)
      let {
        haveJob, noJobNoWish, noJobHaveWish,
        dealLostSalary, notDealLostSalary,
        needPersons, workPersons, emptyWorkPersons,
        hiStudentHasJob, hiStudentNoJobNoWish, hiStudentNoJobHaveWish,
        soldierHasJob, soldierNoJobNoWish, soldierNoJobHaveWish,
        disableHasJob, disableNoJobNoWish, disableNoJobHaveWish,
        fishManHasJob, fishManNoJobNoWish, fishManNoJobHaveWish,
        lostJobHasJob, lostJobNoJobNoWish, lostJobNoJobHaveWish,
      } = data

      let ldwqAll = haveJob + noJobNoWish + noJobHaveWish // 监测总人数=脱贫劳动力
      let ldwqEarlyWarning = dealLostSalary + notDealLostSalary // 预警总人数=已解决总人数+待解决总人数
      let hiStudentAll = hiStudentHasJob + hiStudentNoJobNoWish + hiStudentNoJobHaveWish // 
      let soldierAll = soldierHasJob + soldierNoJobNoWish + soldierNoJobHaveWish // 
      let disableAll = disableHasJob + disableNoJobNoWish + disableNoJobHaveWish // 
      let fishManAll = fishManHasJob + fishManNoJobNoWish + fishManNoJobHaveWish // 
      let lostJobAll = lostJobHasJob + lostJobNoJobNoWish + lostJobNoJobHaveWish // 
      
      data.ldwqAll = ldwqAll
      data.ldwqEarlyWarning = ldwqEarlyWarning
      data.hiStudentAll = hiStudentAll
      data.soldierAll = soldierAll
      data.disableAll = disableAll
      data.fishManAll = fishManAll
      data.lostJobAll = lostJobAll

      if (this.tab_active_name === 'jzfp') {
        this.progress_bar_data1[0].summation = ldwqAll
        this.progress_bar_data1[1].summation = haveJob
        this.progress_bar_data1[2].summation = noJobNoWish
        this.progress_bar_data1[3].summation = noJobHaveWish
        this.progress_bar_data1[0].proportion = ldwqAll === 0 ? 0 : 100
        this.progress_bar_data1[1].proportion = ldwqAll === 0 ? 0 : parseInt((haveJob / ldwqAll) * 100)
        this.progress_bar_data1[2].proportion = ldwqAll === 0 ? 0 : parseInt((noJobNoWish / ldwqAll) * 100)
        this.progress_bar_data1[3].proportion = ldwqAll === 0 ? 0 : parseInt((noJobHaveWish / ldwqAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i].innerHTML = this.progress_bar_data1[i].summation + '人' }
      } else if (this.tab_active_name === 'ldwq') {
        this.progress_bar_data2[0].summation = ldwqAll
        this.progress_bar_data2[1].summation = ldwqEarlyWarning
        this.progress_bar_data2[2].summation = dealLostSalary
        this.progress_bar_data2[3].summation = notDealLostSalary
        this.progress_bar_data2[0].proportion = ldwqAll === 0 ? 0 : 100
        this.progress_bar_data2[1].proportion = ldwqAll === 0 ? 0 : parseInt((ldwqEarlyWarning / ldwqAll) * 100)
        this.progress_bar_data2[2].proportion = ldwqAll === 0 ? 0 : parseInt((dealLostSalary / ldwqAll) * 100)
        this.progress_bar_data2[3].proportion = ldwqAll === 0 ? 0 : parseInt((notDealLostSalary / ldwqAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i + 4].innerHTML = this.progress_bar_data2[i].summation + '人' }
      } else if (this.tab_active_name === 'gwzp') {
        this.progress_bar_data3[0].summation = needPersons
        this.progress_bar_data3[1].summation = workPersons
        this.progress_bar_data3[2].summation = emptyWorkPersons
        this.progress_bar_data3[0].proportion = needPersons === 0 ? 0 : 100
        this.progress_bar_data3[1].proportion = needPersons === 0 ? 0 : parseInt((workPersons / needPersons) * 100)
        this.progress_bar_data3[2].proportion = needPersons === 0 ? 0 : parseInt((emptyWorkPersons / needPersons) * 100)
        for (let i = 0; i < 3; i++) { this.progress_bar_dom[i + 8].innerHTML = this.progress_bar_data3[i].summation + '人' }
      } else if (this.tab_active_name === 'gxxs') {
        this.progress_bar_data4[0].summation = hiStudentAll
        this.progress_bar_data4[1].summation = hiStudentHasJob
        this.progress_bar_data4[2].summation = hiStudentNoJobNoWish
        this.progress_bar_data4[3].summation = hiStudentNoJobHaveWish
        this.progress_bar_data4[0].proportion = hiStudentAll === 0 ? 0 : 100
        this.progress_bar_data4[1].proportion = hiStudentAll === 0 ? 0 : parseInt((hiStudentHasJob / hiStudentAll) * 100)
        this.progress_bar_data4[2].proportion = hiStudentAll === 0 ? 0 : parseInt((hiStudentNoJobNoWish / hiStudentAll) * 100)
        this.progress_bar_data4[3].proportion = hiStudentAll === 0 ? 0 : parseInt((hiStudentNoJobHaveWish / hiStudentAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i + 11].innerHTML = this.progress_bar_data4[i].summation + '人' }
      } else if (this.tab_active_name === 'tyjr') {
        this.progress_bar_data5[0].summation = soldierAll
        this.progress_bar_data5[1].summation = soldierHasJob
        this.progress_bar_data5[2].summation = soldierNoJobNoWish
        this.progress_bar_data5[3].summation = soldierNoJobHaveWish
        this.progress_bar_data5[0].proportion = soldierAll === 0 ? 0 : 100
        this.progress_bar_data5[1].proportion = soldierAll === 0 ? 0 : parseInt((soldierHasJob / soldierAll) * 100)
        this.progress_bar_data5[2].proportion = soldierAll === 0 ? 0 : parseInt((soldierNoJobNoWish / soldierAll) * 100)
        this.progress_bar_data5[3].proportion = soldierAll === 0 ? 0 : parseInt((soldierNoJobHaveWish / soldierAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i + 15].innerHTML = this.progress_bar_data5[i].summation + '人' }
      } else if (this.tab_active_name === 'cjrs') {
        this.progress_bar_data6[0].summation = disableAll
        this.progress_bar_data6[1].summation = disableHasJob
        this.progress_bar_data6[2].summation = disableNoJobNoWish
        this.progress_bar_data6[3].summation = disableNoJobHaveWish
        this.progress_bar_data6[0].proportion = disableAll === 0 ? 0 : 100
        this.progress_bar_data6[1].proportion = disableAll === 0 ? 0 : parseInt((disableHasJob / disableAll) * 100)
        this.progress_bar_data6[2].proportion = disableAll === 0 ? 0 : parseInt((disableNoJobNoWish / disableAll) * 100)
        this.progress_bar_data6[3].proportion = disableAll === 0 ? 0 : parseInt((disableNoJobHaveWish / disableAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i + 19].innerHTML = this.progress_bar_data6[i].summation + '人' }
      } else if (this.tab_active_name === 'tbym') {
        this.progress_bar_data7[0].summation = fishManAll
        this.progress_bar_data7[1].summation = fishManHasJob
        this.progress_bar_data7[2].summation = fishManNoJobNoWish
        this.progress_bar_data7[3].summation = fishManNoJobHaveWish
        this.progress_bar_data7[0].proportion = fishManAll === 0 ? 0 : 100
        this.progress_bar_data7[1].proportion = fishManAll === 0 ? 0 : parseInt((fishManHasJob / fishManAll) * 100)
        this.progress_bar_data7[2].proportion = fishManAll === 0 ? 0 : parseInt((fishManNoJobNoWish / fishManAll) * 100)
        this.progress_bar_data7[3].proportion = fishManAll === 0 ? 0 : parseInt((fishManNoJobHaveWish / fishManAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i + 23].innerHTML = this.progress_bar_data7[i].summation + '人' }
      } else if (this.tab_active_name === 'qtry') {
        this.progress_bar_data8[0].summation = lostJobAll
        this.progress_bar_data8[1].summation = lostJobHasJob
        this.progress_bar_data8[2].summation = lostJobNoJobNoWish
        this.progress_bar_data8[3].summation = lostJobNoJobHaveWish
        this.progress_bar_data8[0].proportion = lostJobAll === 0 ? 0 : 100
        this.progress_bar_data8[1].proportion = lostJobAll === 0 ? 0 : parseInt((lostJobHasJob / lostJobAll) * 100)
        this.progress_bar_data8[2].proportion = lostJobAll === 0 ? 0 : parseInt((lostJobNoJobNoWish / lostJobAll) * 100)
        this.progress_bar_data8[3].proportion = lostJobAll === 0 ? 0 : parseInt((lostJobNoJobHaveWish / lostJobAll) * 100)
        for (let i = 0; i < 4; i++) { this.progress_bar_dom[i + 27].innerHTML = this.progress_bar_data8[i].summation + '人' }
      }
    },
    // 设置左侧滚动条
    async swiper_handler(areaId) {
      if (this.tab_active_name === 'gwzp') {
        await this.get_swiper_data_gwzp(areaId)
      } else {
        await this.get_swiper_data_fp(areaId)
      }
    },
    get_swiper_data_fp(areaId) {
      this.swiper_data_fp = []
      let requestData = { areaId }
      switch (this.tab_active_name) {
        case 'jzfp': requestData.jobGroup = '贫困人员'; break;
        case 'gxxs': requestData.jobGroup = '高校毕业生'; break;
        case 'tyjr': requestData.jobGroup = '退役军人'; break;
        case 'cjrs': requestData.jobGroup = '残疾人'; break;
        case 'tbym': requestData.jobGroup = '退捕渔民'; break;
        case 'qtry': requestData.jobGroup = '其它失业人员'; break;
        default: console.log('jzfp'); break;
      }
      console.log('%cswiper-requestData:', 'color: #f0f;', requestData)
      return this.$api.get_swiper_data(requestData).then(_res => {
        if (_res.data.status === 0) {
          let _D = JSON.parse(_res.data.data)
          console.log('%cswiper:', 'color: #f00;', _D)
          _D.forEach(o => { this.swiper_data_fp.push(o) })
        } else {
          this._status(_res.data)
        }
      })
    },
    get_swiper_data_gwzp(areaId) {
      this.swiper_data_gwzp = []
      return this.$api.getData(`/user/jobUpdate`, { areaId }).then(_res => {
        if (_res.data.status === 0) {
          let _D = JSON.parse(_res.data.data)
          _D.forEach(o => { this.swiper_data_gwzp.push(o) })
        } else {
          this._status(_res.data)
        }
      })
    },
		// 初始化地图
		initMap() {
			this.map = new AMap.Map('container', {
				resizeEnable: true, // 大小调整
				zoom: this.map_zoom, // 级别
				center: this.map_center, // 中心
				layers: [
					new AMap.TileLayer.Satellite({
						zooms: [3, 20], // 可见级别
						visible: true, // 是否可见
						opacity: 1, // 透明度
						zIndex: 0 // 叠加层级
					})
				],
			})
			AMap.plugin(['AMap.ToolBar'], () => {
				// 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
				this.map.addControl(
					new AMap.ToolBar({
						liteStyle: true // 简易缩放模式，默认为 false
					})
				)
      })
      this.waiting = false
		},
  },
  mounted() {
    this.initPage()
    this.progress_bar_dom = document.getElementsByClassName('el-progress-bar__innerText')
    // 初始化左边进度条，将进度条由原来的百分比形式改为显示'人' 为单位
    Array.from(this.progress_bar_dom).forEach((o, i) => { this.progress_bar_dom[i].innerHTML = 0 + '人' })
  },
  beforeRouteLeave(to, from, next) {
    next(this.$refs.myswiper.myPause())
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/swiperStyle/swiper.min.css';
@import '../publicStyle/map.css';

.swiper {width: 100%;height: 100%;margin-top: 28px;}


// 初版
// /deep/ .el-tabs {overflow: auto;}
// /deep/ .el-tabs__header {margin: 0;}
// /deep/ .el-tabs__item {color: #ccc;} // 设置tab字体颜色
// .tabs-label {font-size: 15px;letter-spacing: 0.1rem;} // 设置tab字体大小
// /deep/ .el-tabs__item.is-active {color: #1be1fe;} // 设置tab激活字体颜色
// /deep/ .el-tabs__nav-wrap::after {background-color: #ccc;} // 设置tab下划线颜色
// /deep/ .el-tabs__active-bar {background-color: #1be1fe;} // 设置tab下划线颜色-激活
// /deep/ .el-tabs__nav {width: 100%;}
// /deep/ #tab-first, /deep/ #tab-second {width: 50%;text-align: center;}

// /deep/ .el-tabs__item {padding: 0px 5px;}

// 2行 先开启初版
// /deep/ .el-tabs__item {padding: 0px 20px!important;}
// /deep/ .el-tabs__active-bar {display: none!important;}
// /deep/ .el-tabs__nav {flex-wrap: wrap;}
// /deep/ .el-tabs__nav-wrap::after {content: none;}


// 修改标点样式 3行
// /deep/ .amap-marker-label::after {display: none;}
// /deep/ .map_province {display: flex;justify-content: flex-start;align-items: center;}
// /deep/ .map_province_title {width: auto; height: 48px;writing-mode: vertical-lr;writing-mode: tb-lr;word-wrap: break-word;white-space: normal;}

// /deep/ .map_province_conter {
  // margin: 0;
  // border-top-right-radius: 0;
  // border-bottom-left-radius: 5px;
// }
.waiting {
  width: 100%;height: 100%;line-height: 600px;text-align: center;
  position: fixed;top:0;left: 0;right: 0;bottom: 0;margin: auto;
  background: rgba(51, 51, 51, 0.8);z-index: 9999;
  font-size: 24px;letter-spacing: 1rem;
}


/deep/ .el-input__inner {
  background: transparent;color:rgb(27, 225, 254);;border: none;
  font-size: 18px;letter-spacing: .2rem;margin: 0 auto;text-align: center;
}
// /deep/ .el-select-dropdown{background: transparent;}
</style>